var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 8,
    viewBox: "0 0 10 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.875 1.5C8.25571 1.5 9.375 2.61929 9.375 4C9.375 5.38071 8.25571 6.5 6.875 6.5H5.0003C5.75916 5.92986 6.25 5.02225 6.25 4C6.25 2.97775 5.75916 2.07014 5.0003 1.5H6.875ZM3.125 6.5C1.74429 6.5 0.625 5.38071 0.625 4C0.625 2.61929 1.74429 1.5 3.125 1.5C4.50571 1.5 5.625 2.61929 5.625 4C5.625 5.38071 4.50571 6.5 3.125 6.5ZM0 4C0 5.72589 1.39911 7.125 3.125 7.125H6.875C8.60089 7.125 10 5.72589 10 4C10 2.27411 8.60089 0.875 6.875 0.875H3.125C1.39911 0.875 0 2.27411 0 4Z",
    fill: "#EF4444"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRes);
export default __webpack_public_path__ + "static/media/res.cf1682364c8309e9fd2899955b0ea0d8.svg";
export { ForwardRef as ReactComponent };